<template>
    <span class="toolbar-wrapper" style="z-index: 10000 !important;">
        <ToolBar class="toolbar fixed top-0 ml-0 w-12"  >
            <template #start>
                <div class="logo-container"><img class="logo" alt="icono corporativo" src="@/assets/logo.svg"></div>
            </template>
            <template #center v-if="formTitle">
                <h2 class="form-title">{{ formTitle }}</h2>
            </template>
            <template #end>
                <ButtonPrime class="toolbar-button" icon="pi pi-bars" @click.prevent="openSideBar()" />
            </template>
        </ToolBar>

        <SidebarPrime v-model:visible="visibleRight" position="right">
            <MenuPrime :model="items" @click="handleMenuClick()" style="width: 90%;"/>
        </SidebarPrime>
    </span>
</template>

<script>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

export default {
    name: 'ToolbarComp',
    setup() {
        const route = useRoute();
        
        const formTitle = computed(() => {
            return route.meta.formulario || '';
        });

        return {
            formTitle,
            // ... otros retornos
        };
    },
    data() {
        return {
            visibleRight: false,
            items: [
                {
                    label: 'Administracion',
                    items: [
                        {
                            label: 'Alumnos',
                            icon: 'pi pi-fw pi-plus',
                            command: () => { this.$router.push({ name: 'asmin-alumnos' }) }
                        },
                        {
                            label: 'Docentes',
                            icon: 'pi pi-fw pi-plus',
                            command: () => { this.$router.push({ name: 'admin-docentes' }) }
                        }
                    ]
                },
                {
                    label: 'Sistema',
                    items: [
                        {
                            label: 'Salir',
                            icon: 'pi pi-fw pi-power-off',
                            command: () => { this.$router.push({ name: 'logout' }) }
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        handleMenuClick() {
            this.visibleRight = !this.visibleRight;
        },
        openSideBar() {
            this.visibleRight = true;
        },
        goTo(route) {
            this.$router.push({ name: route });
        }
    },
};
</script>

<style scoped>
.toolbar-wrapper {
    position: relative;
    z-index: 10;
}

.toolbar {
    height: 50px; /* Ajusta la altura del ToolBar */
    width: 100%;
    padding: 0 0.5rem; /* Ajusta el padding según sea necesario */
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo-container {
    width: 50px; /* Ajusta el tamaño del contenedor del logo */
}

.logo {
    width: 50px; /* Ajusta el tamaño del logo */
}

.form-title {
    font-size: 1.2rem; /* Ajusta el tamaño del título del formulario */
    color: var(--primary-color); /* Ajusta el color del título del formulario */
    margin: 0; /* Elimina el margen superior del título del formulario */
}

.toolbar-button {
    font-size: 1rem; /* Ajusta el tamaño del ícono del botón */
    padding: 0.25rem; /* Ajusta el padding del botón */
}

.pi-bars {
    font-size: 1.5rem; /* Ajusta el tamaño del ícono de la barra */
}
</style>
